import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { disconnect } from "@wagmi/core";
import {
  getMe,
  loginRequest,
  registerRequest,
  googleRequest,
  devLoginRequest,
  logoutRequest,
} from "@/services/auth.service";
import { wagmiConfig } from "@/context/WalletProvider";

const AuthContext = createContext(null);

const resetWallet = async () => {
  try { await disconnect(wagmiConfig); } catch {}
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [wallet, setWallet] = useState({ balance: 0, currency: "USD" });
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const data = await getMe();
      if (data?.user) {
        setUser(data.user);
        setWallet(data.wallet);
        return data.user;
      }
      setUser(null);
      return null;
    } catch (e) {
      setUser(null);
      return null;
    }
  }, []);

  useEffect(() => {
    refresh().finally(() => setLoading(false));
  }, [refresh]);

  const login = async (email, password) => {
    await resetWallet();
    const data = await loginRequest(email, password);
    localStorage.setItem("payd_token", data.token);
    setUser(data.user);
    await refresh();
    return data.user;
  };

  const register = async (payload) => {
    await resetWallet();
    const data = await registerRequest(payload);
    localStorage.setItem("payd_token", data.token);
    setUser(data.user);
    await refresh();
    return data.user;
  };

  const googleLogin = async (credential) => {
    await resetWallet();
    const data = await googleRequest(credential);
    localStorage.setItem("payd_token", data.token);
    setUser(data.user);
    await refresh();
    return data.user;
  };

  const devLogin = async (email, name) => {
    await resetWallet();
    const data = await devLoginRequest(email, name);
    localStorage.setItem("payd_token", data.token);
    setUser(data.user);
    await refresh();
    return data.user;
  };

  const logout = async () => {
    try {
      await logoutRequest();
    } catch {}
    await resetWallet();
    localStorage.removeItem("payd_token");
    setUser(null);
  };

  return (
    <AuthContext.Provider
      value={{ user, wallet, loading, login, register, googleLogin, devLogin, logout, refresh, setWallet }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
